import React, { useState, useEffect } from "react";
import Header from "../../ShareElements/ContentHeader/ContentHeader";
import Circle from "../../../../../Assets/Images/sm-Circle.svg";
import Switch from "../../ShareElements/TextInput/Switch";
import DesktopOnlyOverlay from "../../ShareElements/DesktopOnlyOverlay/DesktopOnlyOverlay";
import UnsavedChangesAlert from "../../ShareElements/UnsavedChangesAlert/UnsavedChangesAlert";
import axios from "axios";
import { Config } from "../../../../../Config";
import Select from "../../ShareElements/Select/Select";
import Rotator from "../../../../../Assets/Images/ButtonLoadingIcon.svg";
import ErrorToast from "../../ShareElements/Toast/ErrorToast";
import InfoToast from "../../ShareElements/Toast/InfoToast";
import IdentityField from "./Components/IdentityField";
import { NavLink } from "react-router-dom";

const EditUser = (props) => {
  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };
  const [Profiles, setProfiles] = useState([]);
  const [ChangesApplied, setChangesApplied] = useState(false);
  const [HasUnsaveChanges, setHasUnsavedChanges] = useState(false);
  const [AddedItemsList, setAddedItemsList] = useState([]);
  const [MaxProfileCount, setMaxProfileCount] = useState();
  const [DataIsLoaded, setDataIsLoaded] = useState(false);
  const [IsLoading, setIsLoading] = useState(false);
  const [HasValidationError, setHasErrors] = useState(false); // to check if there is validation error
  const [UserToEdit, setUserToEdit] = useState();
  const [ErrorToastIsShown, setErrorToastIsShown] = useState(false);
  const [SuccessToastIsShown, setSuccessToastIsShown] = useState(false);
  const [ToastIsShown, setToastIsShown] = useState(false);
  const [InfoToastMessage, setToastMessage] = useState(
    translateText("reset_password_sent_info")
  );
  // If the user has never gone through the wizard, value for firstWizard is null (button disabled)
  // If they did not go through the wizard, value for firstWizard is false
  // If they have already gone through the wizard, value for firstWizard is true
  const [WizardStatus, setWizardStatus] = useState();

  useEffect(() => {
    setUserToEdit(JSON.parse(atob(window.localStorage.getItem("UserToEdit"))));
    let UserData = JSON.parse(atob(window.localStorage.getItem("UserToEdit")));
    checkSuperAdminStatus(UserData.superAdmin);
    getProfilesList();
  }, []);

  const checkSuperAdminStatus = (IsSuAdmin) => {
    if (IsSuAdmin) {
      window.localStorage.setItem("EditUserIsSu", 1);
    } else {
      window.localStorage.setItem("EditUserIsSu", 0);
    }
  };

  const disableDropdowns = (Count) => {
    for (let i = 0; i <= Count; i++) {
      if (document.getElementById("added-row-" + i) !== null) {
        document.getElementById("added-row-" + i).classList.add("disabled");
      }
    }
    document.getElementById("add-btn").classList.add("disabled-add");
  };

  const getUserInfo = () => {
    let User = JSON.parse(atob(window.localStorage.getItem("UserToEdit")));
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL + Config.AuthBaseURL + "/api/user/" + User.id,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        document.getElementById("identity").value =
          Res.data.firstName + " " + Res.data.lastName;
        document.getElementById("username").defaultValue = Res.data.username;
        updateInitialProfilesList(Res.data.roles);
        setWizardStatus(Res.data.firstWizard);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const getProfilesList = () => {
    var Data = JSON.stringify({
      size: 1000,
      start: 0,
      sorts: [{ direction: "DESC", fieldName: "name" }],
    });
    var Req = {
      method: "post",
      baseURL: window._env_.API_URL + Config.AuthBaseURL + "/api/role/search",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        createProfiles(Res.data.results);
        setMaxProfileCount(parseInt(Res.data.results.length));
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const createProfiles = (Data) => {
    let List = [];
    Data.map((Profile) => {
      List.push({
        name: Profile.name,
        id: Profile.id,
      });
    });
    setProfiles(List);
    getUserInfo();
  };

  // since some of the items that exist in the database must be
  // removed from the initial list, this function is used to handle that
  const updateInitialProfilesList = (Data) => {
    let PreSelectedList = [];
    Data.map((Item) => {
      PreSelectedList.push({
        name: Item.name,
        id: Item.id,
      });
    });

    var Data = JSON.stringify({
      size: 1000,
      start: 0,
      sorts: [{ direction: "DESC", fieldName: "name" }],
    });
    var Req = {
      method: "post",
      baseURL: window._env_.API_URL + Config.AuthBaseURL + "/api/role/search",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        let List = [];
        Res.data.results.map((Profile) => {
          List.push({
            name: Profile.name,
            id: Profile.id,
          });
        });
        var FinalList = [];
        PreSelectedList.map((Item) => {
          var Filter = "id";
          var Keyword = Item.id;
          var Selected = List.filter((Obj) => {
            return Obj[Filter] === Keyword;
          });
          var SelectedList = List.filter((Obj) => {
            return Obj[Filter] === Selected[0].id;
          });
          FinalList.push(SelectedList[0]);
        });

        setAddedItemsList(FinalList);
        removePreviousProfiles(FinalList);

        if (window.localStorage.getItem("EditUserIsSu") === "1") {
          setTimeout(() => {
            disableDropdowns(parseInt(Res.data.results.length));
          }, 800);
        }
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  // This function removes the previous items from current Profiles list
  const removePreviousProfiles = (PreSelectedProfiles) => {
    let ProfilesList = []; // list of all profiles in the system

    var Data = JSON.stringify({
      size: 1000,
      start: 0,
      sorts: [{ direction: "DESC", fieldName: "name" }],
    });
    var Req = {
      method: "post",
      baseURL: window._env_.API_URL + Config.AuthBaseURL + "/api/role/search",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        Res.data.results.map((Item) => {
          ProfilesList.push({
            name: Item.name,
            id: Item.id,
          });
        });
        PreSelectedProfiles.map((Profile) => {
          let SelectedItem = ProfilesList.filter((Obj) => {
            return Obj["id"] === Profile.id;
          });
          ProfilesList.splice(ProfilesList.indexOf(SelectedItem[0]), 1);
        });
        setProfiles(ProfilesList);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  const disableSaveBtn = () => {
    document.getElementById("save-btn").classList.add("disabled");
    window.localStorage.setItem("HasUnsaveChanges", 0); // 1 means true, 0 means false
    setChangesApplied(false);
  };
  const enableSave = () => {
    document.getElementById("save-btn").classList.remove("disabled");
    window.localStorage.setItem("HasUnsaveChanges", 1); // 1 means true, 0 means false
    setChangesApplied(true);
  };
  const cancelOperation = () => {
    if (ChangesApplied) {
      setHasUnsavedChanges(true);
    } else {
      document.getElementById("back").click();
    }
  };
  const close = () => {
    setHasUnsavedChanges(false);
  };
  const saveAndLeave = () => {
    document.getElementById("save-btn").click();
    let HasErrors = false;
    AddedItemsList.map((Item, i) => {
      if (
        document.getElementById("select-profile-" + i + "-select") !== null &&
        document.getElementById("select-profile-" + i + "-select").classList
          .length > 1
      ) {
        HasErrors = true;
      }
    });
    if (!HasErrors) {
      setTimeout(() => {
        document.getElementById("back").click();
      }, 1500);
    } else {
      setHasUnsavedChanges(false);
    }
  };
  const discard = () => {
    setHasUnsavedChanges(false);
    document.getElementById("back").click();
  };
  // e is the event passed down to the function where it is called (changing the input value by the user)
  const handleUsernameChange = (e) => {
    enableSave();
    removeUserNameError();
    let Username = e.target.value;
    console.log(Username);
  };
  const addProfile = () => {
    if (MaxProfileCount < parseInt(AddedItemsList.length + 1)) {
      setToastIsShown(true);
      setTimeout(() => {
        setToastIsShown(false);
      }, 4000);
    } else {
      enableSave();
      let NewList = AddedItemsList;
      NewList.push({});
      setAddedItemsList(NewList);
      setDataIsLoaded(!DataIsLoaded);
    }
  };
  const deletePermission = (i) => {
    let DeselectedProfile = {
      id: document.getElementById("select-profile-" + i + "-filter").value,
      name: document.getElementById("pre-selected-select-profile-" + i)
        .innerHTML,
    };
    setMaxProfileCount(MaxProfileCount + 1);
    if (DeselectedProfile.id.length > 0) {
      Profiles.push(DeselectedProfile);
    }
    document.getElementById("added-row-" + i).remove();
    enableSave();
  };
  const validateEntries = () => {
    let Username = document.getElementById("username").value;
    let ProfilesLength = AddedItemsList.length;
    for (let i = 0; i < ProfilesLength; i++) {
      if (document.getElementById("select-profile-" + i + "-filter") !== null) {
        var ProfileId = document.getElementById(
          "select-profile-" + i + "-filter"
        ).value;
        if (ProfileId.length === 0) {
          showEmptyProfileName(i);
        }
      }
    }
    if (Username.length === 0) {
      if (Username.length === 0) {
        showUsernameValidationError("Please enter the username.");
      }
    } else {
      initiateUserEdit();
    }
  };
  const initiateUserEdit = () => {
    if (!HasValidationError) {
      setIsLoading(true);
      editUser(UserToEdit.id);
    }
  };
  const editUser = (EmployeeId) => {
    let User = {
      id: EmployeeId,
      email: document.getElementById("username").value,
      firstWizard: UserToEdit.firstWizard,
    };
    if (document.getElementById("locked-switch-holder").classList.length > 1) {
      User.accountNonLocked = true;
    } else {
      User.accountNonLocked = false;
    }
    if (document.getElementById("active-switch-holder").classList.length > 1) {
      User.enabled = false;
    } else {
      User.enabled = true;
    }
    if (
      document.getElementById("is-superadmin-switch-holder") &&
      document.getElementById("is-superadmin-switch-holder").classList
        .length === 1
    ) {
      User.superAdmin = true;
    } else {
      User.superAdmin = false;
    }

    if (WizardStatus !== null && WizardStatus !== undefined) {
      if (
        document
          .getElementById("wizard-switch-holder")
          .classList.contains("off")
      ) {
        User.firstWizard = true;
      } else {
        User.firstWizard = false;
      }
    }

    let Req = {
      method: "PUT",
      baseURL: window._env_.API_URL + Config.AuthBaseURL + "/api/user",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: User,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        assignRolesToUser(Res.data.id);
      })
      .catch((Err) => {
        console.log(Err);
        setHasUnsavedChanges(false);
        enableSave();
        if (Err.response !== undefined && Err.response.status === 403) {
          showUsernameValidationError("You are not allowed to edit this user.");
        }
        setIsLoading(false);
      });
  };
  const assignRolesToUser = (UserId) => {
    let ProfilesLength = AddedItemsList.length;
    let RolesToAssign = [];
    for (let i = 0; i < ProfilesLength; i++) {
      if (document.getElementById("select-profile-" + i + "-filter") !== null) {
        RolesToAssign.push(
          document.getElementById("select-profile-" + i + "-filter").value
        );
      }
    }
    let Data = {
      rolesId: RolesToAssign,
      userId: UserId,
    };
    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/assignment/role-to-user",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setIsLoading(false);
        disableSaveBtn();
      })
      .catch((Err) => {
        console.log(Err.response);
        setIsLoading(false);
        disableSaveBtn();
      });
  };
  const showEmptyProfileName = (i) => {
    document
      .getElementById("select-profile-" + i + "-select")
      .classList.add("cx-select-error-shown");
  };
  const showUsernameValidationError = (ErroMessage) => {
    document.getElementById("validation-error").innerHTML = ErroMessage;
    document.getElementById("validation-error").style.display = "block";
    document.getElementById("username").classList.add("wrong");
  };
  const removeUserNameError = () => {
    document.getElementById("validation-error").innerHTML = "";
    document.getElementById("validation-error").style.display = "none";
    document.getElementById("username").classList.remove("wrong");
  };
  const requestResetLink = () => {
    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/profile/forget-password",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: {
        email: UserToEdit.email,
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setSuccessToastIsShown(true);
        setTimeout(() => {
          setSuccessToastIsShown(false);
        }, 4000);
      })
      .catch((Err) => {
        console.log(Err.response);
        if (Err.response.data.messages[0] === "User account is locked") {
          setErrorToastIsShown(true);
          setTimeout(() => {
            setErrorToastIsShown(false);
          }, 4000);
        }
      });
  };
  const updateRemainingProfiles = (i) => {
    enableSave();
    // removing the currently selected profile from the list
    let ChosenProfile = document.getElementById(
      "select-profile-" + i + "-filter"
    ).value;
    let ProfileIds = [];
    Profiles.map((Profile) => {
      ProfileIds.push(Profile.id);
    });
    Profiles.splice(ProfileIds.indexOf(ChosenProfile), 1);

    // adding the unselected profile to the dropdown options
    if (
      document.getElementById("select-profile-" + i + "-previous-name").value
        .length > 0
    ) {
      Profiles.push({
        id: document.getElementById("select-profile-" + i + "-previous-value")
          .value,
        name: document.getElementById("select-profile-" + i + "-previous-name")
          .value,
      });
    }
  };

  const handleSuperAdminStatus = () => {
    enableSave();

    if (AddedItemsList.length >= 1) {
      if (
        document.getElementById("is-superadmin-switch-holder").classList
          .length === 1
      ) {
        if (AddedItemsList.length === 0) {
        } else {
          for (let i = 0; i <= AddedItemsList.length; i++) {
            if (document.getElementById("added-row-" + i) !== null) {
              document
                .getElementById("added-row-" + i)
                .classList.add("disabled");
            }
          }
          document.getElementById("add-btn").classList.add("disabled-add");
        }
      } else {
        if (AddedItemsList.length === 0) {
        } else {
          for (let i = 0; i <= AddedItemsList.length; i++) {
            if (document.getElementById("added-row-" + i) !== null) {
              document
                .getElementById("added-row-" + i)
                .classList.remove("disabled");
            }
          }
          document.getElementById("add-btn").classList.remove("disabled-add");
        }
      }
    } else {
      if (
        document.getElementById("is-superadmin-switch-holder").classList
          .length === 1
      ) {
        document.getElementById("add-btn").classList.add("disabled-add");
      } else {
        document.getElementById("add-btn").classList.remove("disabled-add");
      }
    }
  };

  return (
    <div className="main-content security-settings">
      <NavLink to="../" id="back" className="hidden"></NavLink>
      <DesktopOnlyOverlay LangData={props.LangData} />
      {HasUnsaveChanges ? (
        <UnsavedChangesAlert
          close={() => close()}
          saveAndLeave={() => saveAndLeave()}
          discardAndLeave={() => discard()}
        />
      ) : null}
      <Header PageName={translateText("user_management")} />
      <div className="content-header">
        <div className="address">
          <p>{translateText("security_settings")}</p>
          <img src={Circle} alt="." />
          <p>{translateText("user_management")}</p>
          <img src={Circle} alt="." />
          <p>{translateText("edit_user")}</p>
        </div>
      </div>
      <div className="user-management-form">
        <section className="form-header">
          <button className="return" onClick={() => cancelOperation()}>
            <i className="feather-arrow-left"></i>
          </button>
          {UserToEdit === undefined ? null : <p>{UserToEdit.username}</p>}
          <div className="button-group">
            <button onClick={() => cancelOperation()} className="back">
              {translateText("cancel")}
            </button>
            {IsLoading ? (
              <button
                onClick={() => null} //this button is disabled and won't act when loading is set to true
                id="save-btn"
                className="save no-action"
              >
                <img alt="" className="rotator" src={Rotator} />
              </button>
            ) : (
              <button
                onClick={() => validateEntries()}
                id="save-btn"
                className="save disabled"
              >
                {translateText("save")}
              </button>
            )}
          </div>
        </section>
        <section className="form-body">
          <div className="form-head">
            <h1>{translateText("personal_information")}</h1>
          </div>
          <div className="form-field">
            <p className="form-item-label">
              {translateText("identity")}{" "}
              <p className="required less-spaced">*</p>
            </p>
            <input
              type="text"
              id="identity"
              placeholder=""
              disabled={true}
              className="disabled-text-input"
            />
            <p id="validation-error"></p>
          </div>
          <div className="form-field">
            <p className="form-item-label">
              {translateText("username")} <p className="required">*</p>
            </p>
            <input
              type="text"
              id="username"
              placeholder=""
              disabled={true}
              className="disabled-text-input"
            />
          </div>
          <div className="form-field">
            <p className="disabled-text form-item-label">
              {translateText("ad_credentials")}
            </p>
            <input
              type="text"
              id="AD-cred"
              disabled={true}
              placeholder=""
              className="disabled-text-input"
            />
          </div>
          <div className="form-field">
            <p className="form-item-label disabled-text">LDAP</p>
            <input
              type="text"
              id="LDAP"
              disabled={true}
              placeholder=""
              className="disabled-text-input"
            />
          </div>
          <button
            onClick={() => requestResetLink()}
            className="send-reset-pass"
          >
            {translateText("send_reset_password")}
          </button>
          <div className="section-separator"></div>
          <div className="form-head">
            <h1>{translateText("user_settings")}</h1>
          </div>
          <div className="form-field">
            <p className="form-item-label">{translateText("activation")}</p>
            {UserToEdit === undefined ? null : (
              <React.Fragment>
                {UserToEdit.enabled ? (
                  <Switch
                    Id="active"
                    IsActive={true}
                    ChangeEvent={() => enableSave()}
                  />
                ) : (
                  <Switch
                    Id="active"
                    IsActive={false}
                    ChangeEvent={() => enableSave()}
                  />
                )}
              </React.Fragment>
            )}
          </div>
          {parseInt(window.localStorage.getItem("IsSuperAdmin")) === 1 ? (
            <div className="form-field">
              <p className="form-item-label">{translateText("lock_account")}</p>
              {UserToEdit === undefined ? null : (
                <React.Fragment>
                  {UserToEdit.accountNonLocked ? (
                    <Switch
                      Id="locked"
                      IsActive={false}
                      IsDisabled
                      ChangeEvent={() => enableSave()}
                    />
                  ) : (
                    <Switch
                      Id="locked"
                      IsActive={true}
                      ChangeEvent={() => enableSave()}
                    />
                  )}
                </React.Fragment>
              )}
            </div>
          ) : (
            <div className="form-field">
              <p className="form-item-label">{translateText("lock_account")}</p>
              {UserToEdit === undefined ? null : (
                <React.Fragment>
                  {UserToEdit.accountNonLocked ? (
                    <Switch
                      Id="locked"
                      IsActive={true}
                      ChangeEvent={() => enableSave()}
                      IsDisabled
                    />
                  ) : (
                    <Switch
                      Id="locked"
                      IsActive={false}
                      ChangeEvent={() => enableSave()}
                      IsDisabled
                    />
                  )}
                </React.Fragment>
              )}
            </div>
          )}
          {WizardStatus !== undefined ? (
            <div className="form-field">
              <p className="form-item-label">
                {translateText("wizard_completed")}
              </p>
              <React.Fragment>
                {WizardStatus === null ? (
                  <Switch
                    Id="wizard"
                    IsActive={WizardStatus === false ? true : false}
                    ChangeEvent={() => enableSave()}
                    IsDisabled
                  />
                ) : (
                  <Switch
                    Id="wizard"
                    IsActive={WizardStatus === false ? true : false}
                    ChangeEvent={() => enableSave()}
                  />
                )}
              </React.Fragment>
            </div>
          ) : null}
          {window.localStorage.getItem("IsSuperAdmin") === "1" ? (
            <div className="form-field">
              <p className="form-item-label">Superadmin</p>
              {UserToEdit !== undefined ? (
                <Switch
                  Id="is-superadmin"
                  IsActive={UserToEdit.superAdmin}
                  ChangeEvent={() => handleSuperAdminStatus()}
                />
              ) : null}
            </div>
          ) : null}
          <div className="form-field">
            <p className="section-label">
              {translateText("assigned_profile")} <p className="required">*</p>
            </p>
            <section className="profiles-assigned">
              <div className="list">
                {AddedItemsList.length === 0 ? null : (
                  <React.Fragment>
                    {AddedItemsList.map((Item, i) => (
                      <div className="added-item" id={"added-row-" + i}>
                        <React.Fragment>
                          {Item.id ? (
                            <Select
                              Initial={Item.name}
                              Options={Profiles}
                              IsWithId
                              Id={"select-profile-" + i}
                              PreSelected={true}
                              PreSelectedId={Item.id}
                              NoSelectStyles={true}
                              ChangeHandler={() => updateRemainingProfiles(i)}
                              ValidationError="Please specify the Profile."
                            />
                          ) : (
                            <Select
                              Initial={translateText("select_profiles")}
                              Options={Profiles}
                              IsWithId
                              Id={"select-profile-" + i}
                              NoSelectStyles={true}
                              PreSelected={false}
                              ChangeHandler={() =>
                                updateRemainingProfiles(parseInt(i))
                              }
                              ValidationError="Please specify the Profile."
                            />
                          )}
                        </React.Fragment>
                        <button
                          onClick={() => deletePermission(parseInt(i))}
                          className="remove-btn"
                        >
                          <i className="feather-x"></i>
                        </button>
                      </div>
                    ))}
                  </React.Fragment>
                )}
              </div>
              <div className="add" id="add-btn">
                <button onClick={() => addProfile()} className="add-to-list">
                  <i className="feather-plus"></i>
                  {translateText("add")}
                </button>
              </div>
            </section>
          </div>
        </section>
      </div>
      {ErrorToastIsShown ? (
        <ErrorToast
          ErrorMessage={
            "Reset Password email was not sent because the account is locked."
          }
        />
      ) : null}
      {SuccessToastIsShown ? (
        <InfoToast
          InfoMessage={InfoToastMessage}
          dismiss={() => setSuccessToastIsShown(false)}
        />
      ) : null}
      {ToastIsShown ? (
        <div className="snackbar">
          <p>{translateText("profiles_have_been_added_toast_text")}.</p>
          <button onClick={() => setToastIsShown(false)}>
            {translateText("dismiss").toUpperCase()}
          </button>
        </div>
      ) : null}
    </div>
  );
};
export default EditUser;
